module.exports = __webpack_public_path__ + "img/IMG_1401_L_BlackMatted.3747c450.jpg";